import type {UploadTicketingFileResponse} from './types';
import type {AsyncThunk} from '@reduxjs/toolkit';

import {PaperClipOutlined} from '@ant-design/icons';
import {Button} from '@ds/components';
import {toast} from '@Toast';
import {useRef, useState} from 'react';
import {useAppDispatch} from 'store';

type UploadAttachmentPayload = {
  file: FormData;
  id: string | number;
};

type AttachmentUploaderProps = {
  vendorId: string | number;
  uploadAttachment: AsyncThunk<unknown, UploadAttachmentPayload, object>;
  onUploadSuccess: (response: UploadTicketingFileResponse) => void;
};

const AttachmentUploader: React.FC<AttachmentUploaderProps> = ({
  vendorId,
  uploadAttachment,
  onUploadSuccess,
}) => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    setUploading(true);

    try {
      const response = (await dispatch(
        uploadAttachment({file: formData, id: vendorId})
      ).unwrap()) as UploadTicketingFileResponse | undefined;
      if (!response?.data?.file_key) {
        toast('خطا در بارگذاری فایل.');
        return;
      }
      onUploadSuccess(response);
    } catch {
      toast('خطا در بارگذاری فایل.');
    } finally {
      setUploading(false);
      event.target.value = '';
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" className="hidden" onChange={handleFileChange} />
      <Button
        type="button"
        variant="outline"
        color="secondary"
        size="md"
        loading={uploading}
        startIcon={<PaperClipOutlined aria-hidden />}
        onClick={() => inputRef.current?.click()}
      >
        افزودن فایل
      </Button>
    </>
  );
};

export default AttachmentUploader;
